import * as api from './api';
import * as types from './mutations';
import { Loading } from 'element-ui';
const qs = require('qs')

let loadingService = undefined;

const startLoadingService = () => {
    loadingService = Loading.service({
        fullscreen: true,
        lock: true,
        text: `Registration in progress - please wait a moment...`
    });
};

const stopLoadingService = () => {
    loadingService.close();
};

const state = {
    events: [],
    activeEvent: undefined,
    registrationSuccess: false,
    isProcessing: false,
    eventFaqs: [],
    eventSpeakers: [],
    eventSessions: [],
    eventSponsors: [],
    eventTickets: [],
    mcd: {
        data: undefined,
        completed: false,
        message: '',
        form: '',
    },
    event: {}
};

const getters = {
};

const mutations = {
    [types.UPDATE_EVENTS](state, events) {
        state.events = events;
    },

    [types.UPDATE_EVENT](state, event) {
        state.activeEvent = event;
    },

    [types.UPDATE_EVENT_FAQS](state, eventFaqs) {
        state.eventFaqs = eventFaqs;
    },

    [types.UPDATE_EVENT_SPEAKERS](state, eventSpeakers) {
        state.eventSpeakers = eventSpeakers;
    },

    [types.UPDATE_EVENT_SESSIONS](state, eventSessions) {
        state.eventSessions = eventSessions;
    },

    [types.UPDATE_EVENT_TICKETS](state, eventTickets) {
        state.eventTickets = eventTickets;
    },

    [types.UPDATE_EVENT_SPONSORS](state, eventSponsors) {
        state.eventSponsors = eventSponsors;
    },

    [types.SET_REGISTRATION_SUCCESS_STATE](state, isSuccess) {
        state.registrationSuccess = isSuccess;
    },

    [types.SET_PROCESSING_STATE](state, isProcessing) {
        state.isProcessing = isProcessing;
    },

    [types.SET_CURRENT_MCD](state, mcd) {
        state.mcd.data = mcd;
    },

    [types.SET_CURRENT_EVENT](state, event) {
        state.event = event;
    },

    [types.SET_REGISTER_STATE](state, payload) {
        state.mcd.completed = payload.completed;
        state.mcd.message = payload.message;
    },

    [types.SET_MCD_REGO_FORM](state, form) {
        state.mcd.form = form;
    }
};

const actions = {
    isDownloadable({}, {event_id, email, session}) {
        return new Promise((resolve, reject) => {
            eventHttpClient.post(api.isDownloadable, { event_id, email, session })
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => reject(response));
        });
    },

    getEvent({state, commit}, { code, query}) {
        const queryString = qs.stringify(query)

        if (state.event && state.event.event && state.event.event.code === code) return;

        return new Promise((resolve, reject) => {
            eventHttpClient.get(`${api.getEvent(code)}?${queryString}`)
                .then(({data}) => {
                    commit(types.SET_CURRENT_EVENT, data);
                    resolve(data)
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getEventsListing({commit, state}, filter) {
        if (state.events.length) return;

        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventsListing(filter))
                .then(({data}) => {
                    commit(types.UPDATE_EVENTS, data);
                    resolve(data);
                    return data
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getMcdEvent({commit, state}, eventHashedId) {
        if (state.mcd.data) return;

        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getMcdEvent(eventHashedId))
                .then(({data}) => {
                    commit(types.SET_CURRENT_MCD, data.mcd.data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    findEvent({commit}, slug) {
        commit(types.SET_PROCESSING_STATE, true);

        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.findEvent(slug))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT, data.data);

                    resolve(data.data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    mcdRegisterFree(_, {payload, eventId}) {
        return new Promise((resolve, reject) => {
            startLoadingService();

            eventHttpClient.post(api.mcdRegisterFree(eventId), {...payload})
                .then(({data}) => resolve(data.attendee.data))
                .catch(({response}) => reject(response))
                .done(_ => stopLoadingService());
        });
    },

    mcdRegister(_, {payload, eventId, endpoint}) {
        return new Promise((resolve, reject) => {
            startLoadingService();

            eventHttpClient.post(api[endpoint](eventId), {...payload})
                .then(({data}) => {
                    resolve(data)
                })
                .catch(({response}) => reject(response))
                .done(_ => stopLoadingService());
        });
    },

    getPublicFaqs({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getPublicEventFaqs(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_FAQS, data.faqs);
                    resolve(data.faqs);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getFaqs({commit}, eventId) {
        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventFaqs(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_FAQS, data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getPublicSpeakers({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getPublicEventSpeakers(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SPEAKERS, data.speakers);
                    resolve(data.speakers);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getSpeakers({commit}, eventId) {
        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventSpeakers(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SPEAKERS, data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getPublicSessions({commit}, eventId) {
        return new Promise((resolve, reject) => {
            axios.get(api.getPublicEventSessions(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SESSIONS, data.sessions);
                    resolve(data.sessions);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getSessions({commit}, eventId) {
        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventSessions(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SESSIONS, data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getTickets({commit}, eventId) {
        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventTickets(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_TICKETS, data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    },

    getSponsors({commit}, eventId) {
        return new Promise((resolve, reject) => {
            eventHttpClient.get(api.getEventSponsors(eventId))
                .then(({data}) => {
                    commit(types.UPDATE_EVENT_SPONSORS, data);
                    resolve(data);
                })
                .catch(({response}) => reject(response))
                .done(_ => commit(types.SET_PROCESSING_STATE, false));
        });
    }
};

export default {
    namespaced: true,
    state,
    actions,
    mutations,
    getters
};
